import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { showsSiteFooter } from 'src/app/core/utils/site-footer.util';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-ic-main',
  templateUrl: './ic-main.component.html',
  styleUrls: ['./ic-main.component.scss']
})
export class IcMainComponent implements OnInit {

  settingsData: any = {};
  settingsDataSubscription: Subscription;
  routerevents: Subscription;
  is_show_musicPlayer = false;
  mediaPlayerDataSubscription: Subscription;
  deviceData: Subscription;
  appType: any;
  screenStatusSubscription:Subscription;
  leftMenu: boolean = false;

  constructor(public router: Router, private commanSubscribeService: CommanSubscribeService,
    public route: ActivatedRoute, private storageService: StorageService,private cdRef:ChangeDetectorRef) {

    this.routerevents = router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
      }
    });

  }

  devicetype: any;
  ngOnInit() {
    // Owned by this layout (not the pages inside it): styles.scss paints body:not(.home)
    // grey, so a child page dropping the class on destroy turned every later page grey
    // until a refresh re-added it.
    document.body.classList.add('home');
    this.appType = this.storageService.getItem('app_type');
    this.devicetype = this.commanSubscribeService.deviceType;
    this.deviceData = this.commanSubscribeService.getAppType().subscribe(response => {
      this.devicetype = response;
    })
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
    });

    this.screenStatusSubscription = this.commanSubscribeService.getScreenStatus().subscribe(response => {
      this.leftMenu = response;
      this.cdRef.detectChanges();
    });

    if (this.commanSubscribeService.mediaPlayerData.is_show_musicPlayer) {
      this.is_show_musicPlayer = true;
    } else {
      this.is_show_musicPlayer = false;
    }
    this.mediaPlayerDataSubscription = this.commanSubscribeService.getMediaPlayerData().subscribe(response => {
      if (response.key == "is_show_musicPlayer") {
        this.is_show_musicPlayer = response.value;
      }
    });

  }
  get showFooter(): boolean {
    return showsSiteFooter(this.router.url, this.appType);
  }

  get containerStyles(): any {
  const isMerchandise = this.router.url.includes('/merchandise');
  const isEvent = this.router.url.includes("/event")
  return {
    'background-color': isMerchandise ? this.settingsData?.merchandise_bg_main_color : isEvent ? this.settingsData?.event_bg_main_color : this.settingsData?.main_bg_color || null,
    'font-family': this.settingsData?.font_family || null,
  };
  }

  isLeftMenuRoute() {
    const url = this.router.url;
    const leftMenuPaths = [
      '/place-order',
      '/event/schedule',
      '/event/private-chat',
      '/event/contacts'
    ];
    return leftMenuPaths.some(path => url.includes(path));
  }
  

  ngOnDestroy() {
    document.body.classList.remove('home');
    if (this.routerevents)
      this.routerevents.unsubscribe();
    if (this.settingsDataSubscription)
      this.settingsDataSubscription.unsubscribe();
    if (this.mediaPlayerDataSubscription) {
      this.mediaPlayerDataSubscription.unsubscribe();
    }
    if(this.screenStatusSubscription){
      this.screenStatusSubscription.unsubscribe();
    }
  }

}
